export const isPartnerLandingPath = (pathname = '') => {
  const path = String(pathname).replace(/\/+$/, '') || '/';
  return path === '/partner';
};

export const shouldHideAppNavbar = (pathname = '') => {
  const path = String(pathname).replace(/\/+$/, '') || '/';
  return /^\/packages\/[^/]+$/.test(path);
};
